import React, {Component} from 'react'
import Cleave from 'cleave.js/react';
 
class CustomCurrencyInput extends Component {

    constructor(props){
        super(props);
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    onChangeHandler(event){
        this.props.onChange(parseFloat(event.target.rawValue));
    }

    render() {
        return (
            <div>
                <Cleave className={this.props.className} inputMode={'decimal'} placeholder={this.props.placeholder} onChange={this.onChangeHandler} options={{numeral: true, numelThousandsGroupStyle: 'thousand', numeralDecimalScale: 2, numeralDecimalMark: ',', delimiter: '.', prefix: '$', noImmediatePrefix: true, rawValueTrimPrefix: true}} />
            </div>
        );
    }
}

export default CustomCurrencyInput


/** WEBPACK FOOTER **
 ** ./src/components/CustomCurrencyInput.js
 **/